import history from '../../util/history'

const onCancell = () => {
  history.goBack()
}
export default onCancell
